import { render, staticRenderFns } from "./SegRenovacion.vue?vue&type=template&id=2c9d4666&scoped=true&"
import script from "./SegRenovacion.vue?vue&type=script&lang=js&"
export * from "./SegRenovacion.vue?vue&type=script&lang=js&"
import style0 from "./SegRenovacion.vue?vue&type=style&index=0&id=2c9d4666&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9d4666",
  null
  
)

export default component.exports